import React from 'react';
import {
  Timeline,
  Text,
  Box,
  Container,
  Title,
  Stack,
  Flex,
  useMantineTheme,
} from '@mantine/core';
import { useId } from '@mantine/hooks';
import { HiOutlineMusicalNote, HiOutlinePaintBrush, HiOutlineQrCode } from 'react-icons/hi2';

function HomePageTimeline() {

  const { colors } = useMantineTheme();
  const iconProps = {
    color: colors.violet[8],
    size: 20,
  };

  const timelineStyles = {
    itemBullet: {
      outline: '0.5rem solid white',
    },
    item: {
      paddingLeft: 44,
    },
    itemBody: {
      paddingTop: 8,
    },
    itemTitle: {
      marginBottom: 8,
      fontWeight: 600,
    }
  };

  const steps = [
    {
      key: useId(),
      icon: <HiOutlineMusicalNote {...iconProps} />,
      title: 'Choose the mix',
      body: 'Select any playlist on Spotify – even from your own library.',
    },
    {
      key: useId(),
      icon: <HiOutlinePaintBrush {...iconProps} />,
      title: 'Set the mood',
      body: 'Customize colors, icons, and fonts to complement your tracks.',
    },
    {
      key: useId(),
      icon: <HiOutlineQrCode {...iconProps} />,
      title: 'Showcase your brand',
      body: 'Add your logo & a custom QR code to every game card.',
    }
  ];

  return (
    <Box>
      <Container px='xl' pt={0} pb={{ md: 40 }} >
        <Flex direction={{ base: 'column', md: 'row' }} align={{ md: 'center' }} gap={{ base: 0, md: 80 }}>
          <Stack spacing='xs' mb={32}>
            <Title size='h3' order={2}>
              Start to finish in minutes
            </Title>
            <Text color='gray.7'>
              Design & print up to 300 unique game cards with only a few clicks.
            </Text>
          </Stack>
          <Timeline active={2} color='violet.0' bulletSize={44} lineWidth={1.5} styles={timelineStyles}>
            { steps.map(({ key, title, icon, body }) => (
              <Timeline.Item key={key} title={title} bullet={icon} lineVariant='solid'>
                <Text color='gray.7'>{body}</Text>
              </Timeline.Item>
            )) }
          </Timeline>
        </Flex>
      </Container>
    </Box>
  );
}

export default HomePageTimeline;